import { useEffect, useState } from 'react'

/**
 * Returns the debounced value only after the passed value hasn't changed in the passed delay time
 * @param value
 * @param delay
 * @returns debouncedValue
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(
    () => {
      const timer = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)

      return () => {
        clearTimeout(timer)
      }
    },
    [value, delay],
  )

  return debouncedValue
}
